import React from 'react';
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { isInternalURL, toBackendLang } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { keys, isEmpty, map, filter } from 'lodash';
import { Dropdown } from 'semantic-ui-react';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useWindowSize } from "../../helpers";
import { FormattedMessage } from 'react-intl';


const NavItem = ({ item, lang, mobile }) => {
  const { settings } = config;
  const size = useWindowSize();
  const subItems = item.items

  if (isInternalURL(item.url) || item.url === '') {
    return (
      <>
        {(!isEmpty(item.items) && size >= 1280 && !mobile) ? (
          <Dropdown
            text={item.title}
            inline
            basic
            item
          >

            <Dropdown.Menu className="mnPrincipal__second">
              <div className="mnPrincipal__second__wrapper">
                <Dropdown.Header >
                  <NavLink
                    to={item.url === '' ? '/' : item.url}
                    key={item.url}
                    className="item item__header" 
                    exact={
                      settings.isMultilingual
                        ? item.url === `/${toBackendLang(lang)}`
                        : item.url === ''
                    }
                  >
                    <strong className='fs-3 fw-bold'>{item.title}</strong> <FontAwesomeIcon icon={faArrowRight} />
                  </NavLink>
                 
                </Dropdown.Header>

                <ul className="mnPrincipal__second__list list-unstyled">
                  {map(subItems, (item, index) => (
                    <Dropdown.Item key={index} as='li'>
                      <UniversalLink
                        href={item?.getRemoteUrl ? item?.getRemoteUrl : item['@id']}
                        key={item['@id']}
                        className="item__link">
                        {item.title}
                      </UniversalLink>
                    </Dropdown.Item>
                  ))}
                </ul>

              </div>
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <NavLink
            to={item.url === '' ? '/' : item.url}
            key={item.url}
            className="item"
            activeClassName="active"
            exact={
              settings.isMultilingual
                ? item.url === `/${toBackendLang(lang)}`
                : item.url === ''
            }
          >
            {item.title}
          </NavLink>
        )}
      </>
    );
  } else {
    return (
      <a
        href={item.url}
        key={item.url}
        className="item"
        rel="noopener noreferrer"
        target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
      >
        {item.title}
      </a>
    );
  }
};

export default NavItem;
